module.exports = __webpack_public_path__ + "img/屏幕内容.114bf151.png";